import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { IMutationArgs } from '../types'
import {
  adminListVideoKyCsOptions,
  adminListAgentKyCsOptions,
} from './admin-kyc.options'
import { EAdminKycQueryKey } from './admin-kyc.types'
import type {
  AdminFinalizeVideoKYCInput,
  AdminFinalizeAgentKYCInput,
} from './admin-kyc.types'
import adminKycService from './admin-kyc.service'

export const useAdminListVideoKyCs = (
  params: Parameters<typeof adminListVideoKyCsOptions>[0],
) => {
  return useQuery(adminListVideoKyCsOptions(params))
}

export const useAdminListAgentKyCs = (
  params: Parameters<typeof adminListAgentKyCsOptions>[0],
) => {
  return useQuery(adminListAgentKyCsOptions(params))
}

export const useAdminFinalizeAgentKyc = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args

  return useMutation({
    mutationFn: (data: AdminFinalizeAgentKYCInput) =>
      adminKycService.adminFinalizeAgentKyc(data),
    onSuccess: (data) => {
      if (invalidate) {
        queryClient.invalidateQueries({
          queryKey: [EAdminKycQueryKey.ADMIN_AGENT_KYC_LIST],
        })
      }
      return data
    },
  })
}

export const useAdminFinalizeVideoKyc = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args

  return useMutation({
    mutationFn: (data: AdminFinalizeVideoKYCInput) =>
      adminKycService.adminFinalizeVideoKyc(data),
    onSuccess: (data) => {
      if (invalidate) {
        queryClient.invalidateQueries({
          queryKey: [EAdminKycQueryKey.ADMIN_KYC_LIST],
        })
      }
      return data
    },
  })
}
